import { useNavigate } from 'react-router-dom';
import { CalendarCheckIcon, ConvertIcon } from '../../components/icons';
import { formatMoney } from '../../components/primitives';
import { lockedInStart } from '../../lib/leadStage';
import { useIsMobile } from '../../lib/useIsMobile';
import type { LockedInDue } from './types';

/** Locked-in lead whose start date has arrived (round three §4). The row
    opens the lead, where the banner's Convert to project runs the real
    convert flow. */
export function LockedInAttentionRow({ lead, today }: { lead: LockedInDue; today: string }) {
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const who = lead.company ?? lead.name;
  const when = lockedInStart(lead.resurface_date, today).text;
  const open = () => navigate(`/leads/${lead.id}`);

  if (isMobile) {
    return (
      <div className="row mrow-att" onClick={open}>
        <span className="ico ok"><ConvertIcon /></span>
        <div className="main">
          <div className="ttl">Convert to project — {who}</div>
          <div className="sub">
            <span className="who">Locked in · {lead.name}</span>
            <span className="sep">·</span>
            <span className="ok">{when}</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="row" onClick={open} style={{ cursor: 'pointer' }}>
      <span className="row-icon ic-ok"><CalendarCheckIcon /></span>
      <span className="row-title" title={`Convert to project — ${who}`}>Convert to project — {who}</span>
      <span className="row-context" title={`Locked in · ${lead.name}`}>Locked in · {lead.name}</span>
      <span className="row-spacer" />
      {lead.value_cents !== null && <span className="row-meta gold">{formatMoney(lead.value_cents)}</span>}
      <span className="row-meta ok">{when}</span>
    </div>
  );
}
